import { Capacitor } from '@capacitor/core';

import { OrderStatusModel } from '@portal-clients/order';

import { routes } from './routes';

const TOPUP_CANCELLED_STATUSES: OrderStatusModel[] = ['CANCELLED'];
const TOPUP_FAILED_STATUSES: OrderStatusModel[] = [
  'PAYMENT_FAILED',
  'ERROR',
  'FSGM_FAILED',
];

export const paymentUtils = {
  getReturnUrl(orderType: string, orderId: string, accountId: string): string {
    if (Capacitor.isNativePlatform() && APP_CONFIG.customSchema) {
      return `${APP_CONFIG.customSchema}:/${routes.payment.payment(orderType, orderId, accountId)}`;
    }

    return `${APP_CONFIG.baseUrl || window.location.origin}${routes.payment.payment(orderType, orderId, accountId)}`;
  },
  /**
   * Determines whether a polled topup order has reached a terminal
   * cancelled/failed state that should redirect the guest back to the
   * topup screen instead of leaving them on the payment-status screen
   * indefinitely (e.g. an order stuck as FSGM_FAILED never resolves into
   * one of the success statuses the payment-status screen waits for).
   */
  getTopupTerminalOutcome(
    status: OrderStatusModel | undefined,
  ): 'cancelled' | 'failed' | undefined {
    if (status && TOPUP_CANCELLED_STATUSES.includes(status)) {
      return 'cancelled';
    }

    if (status && TOPUP_FAILED_STATUSES.includes(status)) {
      return 'failed';
    }

    return undefined;
  },
  getCurrencySymbol(locale: string, currency: string): string {
    return (0)
      .toLocaleString(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/\d/g, '')
      .trim();
  },
};
